module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms7-9c9a86aa405ee85b33e419f51c48e06a.jpg";